import { FILTERS_SPECS } from '../actionTypes';

export const setFilterData = action => ({
  type: FILTERS_SPECS.SET_FILTER_DATA,
  payload: action.payload,
});
